import React from 'react'
import PropTypes from 'prop-types'
import Navbar from './Navbar'
import Container from 'orionsoft-parts/lib/components/Container'
import forceLogin from 'orionsoft-parts/lib/decorators/forceLogin'
import Sidebar from './Sidebar'
import NoVerified from './NoVerified'
import NoActive from './NoActive'
import Signature from '../Settings/Signature'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import styles from './styles.css'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import get from 'lodash/get'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import autobind from 'autobind-decorator'
import { MdCheckCircle } from 'react-icons/lib/md'
import TagManager from 'react-gtm-module'

global.onCloseSignature = []
global.selSignature = ''

@withMutation(gql`
  mutation newUserLocation($location: LocationInput) {
    newUserLocation(location: $location){
      success
    }
  }
`)

@withGraphQL(gql`
  query me {
    me {
      _id
      emails {
        address
        verified
      }
      isActive
      roles
      isSimpleAccount
      hasPassword
      lastKnownLocation {
        date
      }
    }
  }
`)
@forceLogin
export default class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    me: PropTypes.obj,
    newUserLocation: PropTypes.func
  }

  state = {
    signatureOpen: false,
    selSignature: undefined,
    setDefault: true
  }

  async newLKL(location) {
    console.log('Llamando a NLKL', location)
    await this.props.newUserLocation(location)
    console.log('Llega LKL')
  }

  /*
  LKLElapsed(){
    let deboLlamar = false;
    if( this.props.me ){
      const me = get(this.props, 'me')
      if(me.lastKnownLocation){
        let lklDate = new Date(me.lastKnownLocation.date);
        const maxMinutosSinLoc = 20;
        let ahora = new Date();
        let elapsed = (ahora.getTime() - lklDate.getTime())/(60 * 1000);
        if(elapsed > maxMinutosSinLoc){
          console.log("Paso suficiente tiempo, debo llamar: "+ elapsed)
          deboLlamar = true;
        } else {
          console.log("Aun no pasa " + elapsed + "/" + maxMinutosSinLoc );
        }
      } else {
        deboLlamar = true
        console.log("No existe LKL,debo llamar")
      }

      if(deboLlamar){
        console.log("Procedo a newLKL");
        this.consultarLocalizacion();
        this.newLKL(
          {
            latitud: this.state.latitud,
            longitud: this.state.longitud 
          });
      }
    }
  }
  */
  componentWillRecieveProps(nextProps) {
    if (!nextProps.data.loading && this.props.data.loading) {
      // console.log("Algo llega")
    }
  }

  componentDidMount() {
    global.openSignature = () => {
      this.setState({ signatureOpen: true })
    }

    global.getSignature = async () => {
      return new Promise(resolve => {
        global.onCloseSignature.push(resolve)
      })
    }

    global.getSelSignature = async () => {
      this.setState({ signatureOpen: true, setDefault: false })
      return await this.state.selSignature
    }

    global.closeSignature = signatureId => {
      this.setState({ signatureOpen: false, setDefault: true })
      for (const callback of global.onCloseSignature) {
        callback(signatureId)
      }
      global.onCloseSignature = []
    }
    /*
    if ("geolocation" in navigator) {
      try{
        navigator.geolocation.getCurrentPosition(function(position) {
          this.setLocationState( position.coords.latitude, position.coords.longitude);
        });
      } catch(exception){
        console.log("No logre obtener localizacion");
        this.setLocationState(0,0);
      }
    } else {
      this.setLocationState(0,0);
      console.log("Localizacion no disponible");
    }
    */
    this.consultarLocalizacion()
  }

  consultarLocalizacion() {

    /*
    if( !this.props.isGeolocationAvailable ) {
      console.log("!geolocationAvailable")
    } else {
      console.log("geolocationAvailable")
      if( !this.props.isGeolocationEnabled ){
        console.log("!isGeolocationEnabled")
      } else {
        console.log("isGeolocationEnabled")
        if(this.props.coords){
          tengoLocation = true;
        } else {
          console.log("!Coords")
        }
      }
    }
    if(tengoLocation){
      console.log("Tengo location")
      this.setState({
        'latitud': this.props.coords.latitude,
        'longitud': this.props.coords.longitude
      })
    } 
    */
  }
  /*
  setLocationState(latitud, longitud){
    console.log("setLocationState "+ latitud + "-" + longitud);
    this.setState({
      'latitud': latitud,
      'longitud': longitud
    })
    console.log("state seteado...");
  }
  */

  @autobind
  async signReady(signatureId) {
    console.log("signReady", signatureId);
    await this.setState({ selSignature: signatureId })
    console.log("Vuelve");
  }

  renderSignature() {
    return (
      <ReactCSSTransitionGroup
        transitionName="user-menu"
        transitionEnterTimeout={200}
        transitionLeaveTimeout={200}
      >
        {this.state.signatureOpen ? <Signature isReady={this.signReady} isDefault={this.state.setDefault}/> : null}
      </ReactCSSTransitionGroup>
    )
  }

  renderNormal() {
    const tagManagerArgs = {
      gtmId: 'GTM-P9GD3WS'
    }
    TagManager.initialize(tagManagerArgs);
    return (
      <div className={'Layout ' + styles.container}>
        <Navbar />
        <Container>
          <div className="row">
            <div className="col-xs-12 col-sm-3 sidebar-container">
              <Sidebar />
              
            </div>
            <div
              className="col-xs-12 col-sm-9"
              style={{ marginBottom: '54px' }}
            >
              {this.props.children}
            </div>
          </div>
        </Container>
        {this.renderSignature()}
      </div>
    )
  }

  render() {
    console.log('Route: /Layout')
    const me = get(this.props, 'me') || {}
    const roles = me.roles || []
    const email = get(me, 'emails.0') || {}
    if (!me.isActive) {
      console.log('me not active')
      return <NoActive />
    }
    // this.LKLElapsed()
    if (!roles.includes('admin') && !email.verified) {
      console.log('me not verified')
      return <NoVerified />
    } else {
      return this.renderNormal()
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Layout/index.js